import React from 'react';
import SupportUtilitiesComponent from './support-utilities.component';

const SupportUtilities = (props) => {
    return <SupportUtilitiesComponent {...props} />;
};

export default SupportUtilities;
